    // src/redux/Company/actions.js

    import api from "../../config/base";
    import {
    FETCH_COMPANIES_SUCCESS,
    FETCH_COMPANIES_FAILURE,
    FETCH_COMPANY_SUCCESS,
    FETCH_COMPANY_FAILURE,
    CREATE_COMPANY_SUCCESS,
    CREATE_COMPANY_FAILURE,
    UPDATE_COMPANY_SUCCESS,
    UPDATE_COMPANY_FAILURE,
    DELETE_COMPANY_SUCCESS,
    DELETE_COMPANY_FAILURE,
    } from "./types";

    // Get all companies
    export const fetchCompanies = () => async (dispatch) => {
    try {
        const res = await api.get('/company');
        dispatch({
        type: FETCH_COMPANIES_SUCCESS,
        payload: res.data,
        });
    } catch (error) {
        dispatch({
        type: FETCH_COMPANIES_FAILURE,
        payload: error.message,
        });
    }
    };

    // Get a company by ID
    export const fetchCompanyById = (id) => async (dispatch) => {
    try {
        const res = await api.get(`/company/${id}`);
        dispatch({
        type: FETCH_COMPANY_SUCCESS,
        payload: res.data,
        });
    } catch (error) {
        dispatch({
        type: FETCH_COMPANY_FAILURE,
        payload: error.message,
        });
    }
    };

    // Create a new company
    export const createCompany = (company) => async (dispatch) => {
    try {
        const res = await api.post('/company', company);
        dispatch({
        type: CREATE_COMPANY_SUCCESS,
        payload: res.data,
        });
    } catch (error) {
        dispatch({
        type: CREATE_COMPANY_FAILURE,
        payload: error.message,
        });
    }
    };

    // Update a company by ID
    export const updateCompany = (id, company) => async (dispatch) => {
    try {
        const res = await api.put(`/company/${id}`, company);
        dispatch({
        type: UPDATE_COMPANY_SUCCESS,
        payload: res.data,
        });
    } catch (error) {
        dispatch({
        type: UPDATE_COMPANY_FAILURE,
        payload: error.message,
        });
    }
    };

    // Delete a company by ID
    export const deleteCompany = (id) => async (dispatch) => {
    try {
        await api.delete(`/company/${id}`);
        dispatch({
        type: DELETE_COMPANY_SUCCESS,
        payload: id,
        });
    } catch (error) {
        dispatch({
        type: DELETE_COMPANY_FAILURE,
        payload: error.message,
        });
    }
    };
